import { quickNews } from '@/mocks/haijiao';

export default function FeedTimeline() {
  return (
    <section id="feed" className="bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <p className="text-sm font-semibold tracking-widest text-accent-600">快讯时间线</p>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              编辑部最新动态
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            规则、攻略、教程与热榜的更新都会沉淀在这里，随点随看。
          </p>
        </div>

        <div className="mt-10 space-y-0 border-l-2 border-background-300 pl-6 md:pl-8">
          {quickNews.map((n) => (
            <article key={n.time} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[31px] top-1 flex h-4 w-4 items-center justify-center rounded-full border-2 border-accent-400 bg-background-50 md:-left-[39px]"></span>
              <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-medium text-accent-700">
                    {n.category}
                  </span>
                  <time className="text-xs text-foreground-400">{n.time}</time>
                </div>
                <span className="text-xs text-foreground-400">热度 {n.hot}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-semibold text-foreground-950 md:text-xl">
                <a href="#feed" className="transition-colors hover:text-primary-700">
                  {n.title}
                </a>
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{n.digest}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}